// content_option.js

export const dataportfolio = [
    {
        title: "QuantumGuard",
        img: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&w=800&q=80",
        description: "Advanced security application featuring Post-Quantum Cryptography to future-proof enterprise data.",
        techStack: ["Rust", "WebAssembly", "Cryptography"],
        link: "https://github.com/yourusername/quantumguard",
        symbol: "cybersecurity" 
    },
    {
        title: "Education Cloud V1.0",
        img: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=800&q=80",
        description: "Highly scalable, multi-tenant deployment architecture for global education platforms.",
        techStack: ["AWS", "Kubernetes", "Terraform"],
        link: "https://github.com/yourusername/edu-cloud",
        symbol: "cloud_architecture" 
    },
    {
        title: "DriveSync Mobile",
        img: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?auto=format&fit=crop&w=800&q=80",
        description: "Real-time synchronization and management platform engineered for offline-first mobile environments.",
        techStack: ["React Native", "SQLite", "WebSockets"],
        link: "https://github.com/yourusername/drivesync",
        symbol: "mobile_development" 
    },
    {
        title: "CineAI",
        img: "https://images.unsplash.com/photo-1485846234645-a62644f84728?auto=format&fit=crop&w=800&q=80",
        description: "Machine learning integrated media platform that automatically tags and categorizes raw video footage.",
        techStack: ["Python", "TensorFlow", "FastAPI"],
        link: "https://github.com/yourusername/cineai",
        symbol: "ai_machine_learning" 
    },
    {
        title: "Enterprise POS Dashboard",
        img: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=800&q=80",
        description: "High-performance data manipulation dashboard processing millions of transaction rows with zero lag.",
        techStack: ["React", "D3.js", "Node.js"],
        link: "https://github.com/yourusername/enterprise-pos",
        symbol: "data_manipulation" 
    },
    {
        title: "Smart Sparrow UX",
        img: "https://images.unsplash.com/photo-1561070791-2526d30994b5?auto=format&fit=crop&w=800&q=80",
        description: "Award-winning interface design focusing on cognitive load reduction and seamless user journeys.",
        techStack: ["Figma", "Framer Motion", "CSS Variables"],
        link: "https://github.com/yourusername/smart-sparrow",
        symbol: "ui_ux_design" 
    }
];

// Optional: You can also export other static site data here to keep things organized
export const metaData = {
    title: "My AI-Driven Portfolio",
    description: "A portfolio that adapts to your reading behavior and interests.",
};